import React from 'react';
import {
  Grid, CardContent, Typography, CardMedia, Card,
} from '@mui/material';

type Props ={
  isMobilePreview?: boolean;
  image?: string,
  description: React.ReactElement,
  TextColor: string,
}
const BenefitCard:React.FC<Props> = ({
  image, description, TextColor, isMobilePreview,
}) => (
  <Card sx={{
    boxShadow: 'none',
    height: '100%',
  }}
  >
    <Grid container height="100%">
      {image && (
        <Grid size={{ xs: 12, sm: isMobilePreview ? 12 : 4 }}>
          <CardMedia
            sx={{
              minHeight: {
                xs: 'unset',
                sm: '19.2rem',
              },
              objectFit: 'cover',
            }}
            component="img"
            image={image}
            alt="cash back image"
          />
        </Grid>
      )}
      <Grid size={{ xs: 12, sm: isMobilePreview || !image ? 12 : 8 }}>
        <CardContent sx={{
          backgroundColor: 'primary.main',
          px: 2,
          height: isMobilePreview || !image ? 'unset' : '100%',
          display: 'flex',
          alignItems: 'center',
        }}
        >
          <Typography variant="caption" color={TextColor} sx={{ py: { xs: 3, md: isMobilePreview ? 3 : 0 } }}>
            {description}
          </Typography>
        </CardContent>
      </Grid>
    </Grid>
  </Card>
);

export default BenefitCard;
